import { Switch, Route } from "wouter"
import { PublicLayout } from "./components/layout/PublicLayout"
import { AdminLayout } from "./components/layout/AdminLayout"
import { AdminGuard } from "./components/AdminGuard"
import { ArealSelectionPage } from "./pages/ArealSelectionPage"
import { CampDetailPage } from "./pages/CampDetailPage"
import { ReservationPage } from "./pages/ReservationPage"
import { ReservationDetailPage } from "./pages/ReservationDetailPage"
import { GuestPage } from "./pages/GuestPage"
import { AdminLoginPage } from "./pages/admin/AdminLoginPage"
import { AdminRegisterPage } from "./pages/admin/AdminRegisterPage"
import { AdminForgotPasswordPage } from "./pages/admin/AdminForgotPasswordPage"
import { AdminResetPasswordPage } from "./pages/admin/AdminResetPasswordPage"
import { AdminDashboardPage } from "./pages/admin/AdminDashboardPage"
import { AdminPricingPage } from "./pages/admin/AdminPricingPage"
import { AdminAccessCodesPage } from "./pages/admin/AdminAccessCodesPage"
import { AdminArealSettingsPage } from "./pages/admin/AdminArealSettingsPage"
import { AdminCityReportPage } from "./pages/admin/AdminCityReportPage"
import { AdminBillingPage } from "./pages/admin/AdminBillingPage"
import { AdminSpotMapPage } from "./pages/admin/AdminSpotMapPage"
import { AdminPlatformPage } from "./pages/admin/AdminPlatformPage"
import { JoinPage } from "./pages/JoinPage"
import { ForOwnersPage } from "./pages/ForOwnersPage"
import { LegalPage } from "./pages/LegalPage"
import { NotFoundPage } from "./pages/NotFoundPage"

export const App = () => {
    return (
        <Switch>
            {/* Admin auth pages — no layout, no guard */}
            <Route path="/admin/login" component={AdminLoginPage} />
            <Route path="/admin/register" component={AdminRegisterPage} />
            <Route path="/admin/forgot-password" component={AdminForgotPasswordPage} />
            <Route path="/admin/reset/:token" component={AdminResetPasswordPage} />
            <Route path="/join/:token" component={JoinPage} />
            <Route path="/legal/terms">{() => <LegalPage kind="terms" />}</Route>
            <Route path="/legal/privacy">{() => <LegalPage kind="privacy" />}</Route>

            {/* Admin routes with layout + auth guard */}
            <Route path="/admin" nest>
                <AdminGuard>
                    <AdminLayout>
                        <Switch>
                            <Route path="/" component={AdminDashboardPage} />
                            <Route path="/spot-map" component={AdminSpotMapPage} />
                            <Route path="/pricing" component={AdminPricingPage} />
                            <Route path="/access-codes" component={AdminAccessCodesPage} />
                            <Route path="/city-report" component={AdminCityReportPage} />
                            <Route path="/billing" component={AdminBillingPage} />
                            <Route path="/platform" component={AdminPlatformPage} />
                            <Route path="/settings" component={AdminArealSettingsPage} />
                        </Switch>
                    </AdminLayout>
                </AdminGuard>
            </Route>

            {/* Public guest routes */}
            <Route>
                <PublicLayout>
                    <Switch>
                        <Route path="/a/:slug" component={CampDetailPage} />
                        <Route path="/a/:slug/book" component={ReservationPage} />
                        <Route path="/r/:token" component={ReservationDetailPage} />
                        <Route path="/guest/:token" component={GuestPage} />
                        <Route path="/for-owners" component={ForOwnersPage} />
                        <Route path="/" component={ArealSelectionPage} />
                        <Route component={NotFoundPage} />
                    </Switch>
                </PublicLayout>
            </Route>
        </Switch>
    )
}
